import React from 'react'
import { Language } from './data/types'

interface LanguageToggleProps {
    currentLanguage: Language
    onLanguageChange: (lang: Language) => void
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ currentLanguage, onLanguageChange }) => {
    return (
        <div className="language-toggle">
            <span className="language-toggle-label">Language:</span>
            <div className="language-toggle-buttons">
                <button
                    className={`language-button ${currentLanguage === 'pt' ? 'active' : ''}`}
                    onClick={() => onLanguageChange('pt')}
                >
                    PT
                </button>
                <button
                    className={`language-button ${currentLanguage === 'en' ? 'active' : ''}`}
                    onClick={() => onLanguageChange('en')}
                >
                    EN
                </button>
            </div>
        </div>
    )
}

export default LanguageToggle
